import EquipmentUtils from 'utils/EquipmentUtils';
import TextFormatter from 'utils/TextFormatter';
import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';

export default(state, orderId) => {

    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;
    const equipmentDetails = state.getIn(['workOrderDetails', orderId, 'equipmentDetails', 'details']);
    const bypassBecauseOfFailure = state.getIn(['workOrderDetails', orderId, 'sqcResults', 'bypassBecauseOfFailure']);

    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    const isloading = state.getIn(['workOrderDetails', orderId, 'sqcResults', 'loading']); 

    if (isloading) {
        return currentValidation.setIn([
            'sqc', 'isValid'
        ], false).setIn([
            'sqc', 'message'
        ], 'Please wait. Sqc loading.').setIn([
            'sqc', 'isWarning'
        ], true);
    }

    if (orderStatus === 'NoAccess' || bypassBecauseOfFailure) {
        return currentValidation.setIn([
            'sqc', 'isValid'
        ], true).setIn([
            'sqc', 'message'
        ], null);
    }

    currentValidation = currentValidation.setIn([
        'sqc', 'isValid'
    ], false).setIn([
        'sqc', 'message'
    ], null);

    const serviceTypeId = state.getIn([
        'workOrderDetails',
        orderId,
        'schedulingSystemDetails',
        'details',
        'serviceOrderInfoV2',
        'serviceTypeId'
    ]);

    let isSqcable = false;

    if (serviceTypeId && (serviceTypeId.toLowerCase().includes('tc') || serviceTypeId.toLowerCase().includes('in') || serviceTypeId.toLowerCase().includes('rc') || serviceTypeId.toLowerCase().includes('cs'))) {
        isSqcable = true;
    }

    if (!isSqcable) {
        return currentValidation.setIn([
            'sqc', 'isValid'
        ], true).setIn([
            'sqc', 'message'
        ], '');
    }

    const outletsToSqc = EquipmentUtils.getSqcableEquipment(equipmentDetails);

    let sqcValid = true;
    let sqcValidationMessage = '';
    let sqcWarning = false;

    outletsToSqc.forEach((outlet) => {

        let macAddress = TextFormatter.formatMacAddress(outlet.get('macAddress'));

        if (macAddress) {
            macAddress = macAddress.toLowerCase();
        }

        const sqcDetails = state.getIn(['workOrderDetails', orderId, 'sqcResults', 'details', macAddress]);

        if (!sqcDetails) {
            sqcValid = false;
            sqcValidationMessage = sqcValidationMessage += `No modem levels found for ${outlet.get('macAddress')}.`;
        }

        if (sqcDetails && !sqcDetails.getIn(['data', 'certificate'])) {
            sqcWarning = true;
            sqcValidationMessage = sqcValidationMessage += `No modem levels found for ${outlet.get('macAddress')}.`;
        }

    });

    if (!outletsToSqc || outletsToSqc.count() === 0) {
        sqcValid = false;
        sqcValidationMessage = 'No equipment on the account.';
        sqcWarning = false;
    }

    return currentValidation.setIn([
        'sqc', 'isValid'
    ], sqcValid).setIn([
        'sqc', 'message'
    ], sqcValidationMessage).setIn([
        'sqc', 'isWarning'
    ], sqcWarning);

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/sqcValidator.js